<!--开庭公告-->
<template>
  <div class="notice-container">
    <header-index/>
    <div class="notice-content">
      <div class="notice-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>开庭公告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="notice-top">
        <p class="notice-title">查询开庭公告</p>
        <el-input placeholder="请输入案号、当事人、案由等关键词" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="getNoticeInfo">
          <el-button type="danger" slot="append" @click="getNoticeInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="notice-info">
        <div class="notice-search-menu">
          <span>最新开庭公告</span>
          <div>
            <el-select v-model="region" placeholder="请选择" style="width: 170px;margin-right: 20px" clearable>
              <el-option :label="'全国'" :value="''"/>
              <el-option v-for="item in provincialCode" :label="item.name" :value="item.name"/>
            </el-select>
            <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="年份" style="width: 170px"/>
          </div>
        </div>
        <div class="notice-list">
          <div v-for="info of noticeInfo" class="notice-list-item" @click="getCourtNoticeDetails(info)">
            <p class="notice-small-title">{{ info.summary }}</p>
            <p><span class="notice-gray">案号：</span><span class="notice-black">{{ info.caseNumber }}</span></p>
            <p><span class="notice-gray">上诉人/原告：</span><span class="notice-black">{{ info.plaintiff }}</span></p>
            <p><span class="notice-gray">被上诉人/被告：</span><span class="notice-black">{{ info.defendant }}</span></p>
            <p><span class="notice-gray">开庭日期：</span><span class="notice-black">{{ info.dateHearing }}</span></p>
          </div>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <!--开庭公告详情-->
    <el-dialog title="开庭公告详情" :visible.sync="dialogVisible">
      <el-descriptions :column="1" border>
        <el-descriptions-item>
          <template slot="label">案由</template>
          {{ courtNoticeDetail.summary || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="2" border>
        <el-descriptions-item>
          <template slot="label">案号</template>
          {{ courtNoticeDetail.caseNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">开庭日期</template>
          <span v-if="courtNoticeDetail.dateHearing">{{ $moment(courtNoticeDetail.dateHearing).format('YYYY-MM-DD')}}</span>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">承办部门</template>
          {{ courtNoticeDetail.undertakingDepartment || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">排期日期</template>
          <span v-if="courtNoticeDetail.scheduleDate">{{ $moment(courtNoticeDetail.scheduleDate).format('YYYY-MM-DD')}}</span>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">许可决定日期</template>
          <span v-if="courtNoticeDetail.licenseDecisionDate">{{ $moment(courtNoticeDetail.licenseDecisionDate).format('YYYY-MM-DD')}}</span>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">审判长/主审人</template>
          {{ courtNoticeDetail.presidingJudge || '-'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">原告</template>
          {{ courtNoticeDetail.plaintiff || '-'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">被告</template>
          {{ courtNoticeDetail.defendant || '-'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">法院</template>
          {{ courtNoticeDetail.court || '-'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">法庭</template>
          {{ courtNoticeDetail.tribunal || '-'}}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import {searchCourtNotice,getRegion} from '@/api/enterprise_searchApi'
import page from "@/components/page/pages";
import {courtNoticeDetails} from '@/api/enterpriseDetailsApi'
export default {
  name: "courtNotice",
  components: {Hang, Home_footer, HeaderIndex,page},
  data() {
    return {
      keyword: '',
      cid: 0,
      cityList: {},
      year: '',
      region: '',
      cityJson: cityJson,
      provincialCode: [],
      noticeInfo: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      courtNoticeDetail:{},
      dialogVisible:false,
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getNoticeInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getNoticeInfo();
      }
    },
  },
  methods: {
    /*查询开庭公告*/
    getNoticeInfo() {
      searchCourtNotice({
        keyword: this.keyword,
        region: this.region,
        year: this.year,
        page: this.tablePage.currentPage,
        request: 'form'
      }).then(res => {
        if (res.code==200){
          this.tablePage.total=parseInt(res.content.total);
          this.noticeInfo=res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getNoticeInfo();
    },
    /*开庭公告地域分组*/
    getRegionInfo(){
      getRegion().then(res=>{
        if (res.code==200){
          this.provincialCode=res.content;
        }
      })
    },
    /*开庭公告详情*/
    getCourtNoticeDetails(info){
      courtNoticeDetails({id:info.id,request:'form'}).then(res=>{
        if (res.code==200){
          console.log('开庭公告详情',res.content);
          this.courtNoticeDetail=res.content;
          this.dialogVisible=true;
        }
      })
    }
  },
  mounted() {
    this.getRegionInfo();
    this.getNoticeInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')){
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name){
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.notice-container >>> .notice-content .notice-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}
.notice-container >>> .notice-content .notice-top input::-webkit-input-placeholder {
  color: #333333;
}
.notice-container >>> .notice-content .notice-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}
.notice-container >>> .notice-content .notice-top .el-icon-search {
  font-size: 19px;
}
.notice-container >>> .notice-content .notice-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb__inner a,
.notice-container >>> .notice-content .notice-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.notice-container >>> .notice-content .notice-info .notice-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
.notice-container >>> .el-descriptions-item__label.is-bordered-label {
  color: #333333;
  background: #D6E9FF;
  width: 130px;
}
.notice-container >>> .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #D0E0F2;
  padding: 12px 10px;
  font-size: 14px;
  color: #333333;
}
.notice-container >>> .el-descriptions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.notice-container >>> .el-descriptions__title {
  font-size: 16px;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
}
.notice-container >>> .el-descriptions-item__content {
  min-width: 305px;
}
</style>
<style scoped lang="scss">
.notice-container {
  background: #E7E9F5;

  .notice-content {
    .notice-breadcrumb {
      padding: 10px 18%;
      background: #E7E9F5;
      min-width: 76rem;
    }

    .notice-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 400px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .notice-title {
        color: #ffffff;
        margin: 100px 0 60px;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 100px 0px 60px;
        font-weight: bold;
      }
    }

    .notice-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .notice-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }

      .notice-list {
        .notice-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;

          .notice-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }

          .notice-gray {
            color: #666666;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .notice-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>